import { get } from '../utils'

const url = (host, id) => `${host}/sections/${id}`

export default host => id =>
  get(url(host, id))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)
